import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Cart3DPanel } from '../../panels/cart-3d-panel/cart-3d-panel';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { basket3DActions, selectCart3D } from '../../app/basket-3d-slice';
import { viewerLoadingSelector } from '../../app/viewer-slice';
import { basketActions, useCurrentCart } from '../../app/basket-slice';
import { urls } from '../../navigation';
import { useURLLang } from '../../app/main-slice';
import { showPopup } from '../../app/popup-slice';
import { EventEmitter, eventTypes, events } from '../../app/event-emitter';

export function Cart3DPage() {

    const { cartId: cartIdStr } = useParams();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const langId = useURLLang();


    const cartId = cartIdStr ? Number(cartIdStr) : undefined;
    const loading = useAppSelector(viewerLoadingSelector);
    const cart3D = useAppSelector(selectCart3D);
    const { data: cart, isSuccess } = useCurrentCart();


    useEffect(() => {

        const subscriptionId = EventEmitter.subscribe(eventTypes.VIEWER_EVENTS, (event: string, data: any) => {
            if(event === events.SELECT_EVENT) {
                if(data.type === 'element') {
                    //dispatch(configuratorActions.selectElement(data.id));
                } else if(data.type === 'group') {
                    dispatch(basket3DActions.selectGroup(data.id));
                } else if(data.type === 'group-rotate') {
                    dispatch(basket3DActions.rotateGroup(data.group));
                } 
            } else if(event === events.EMPTYSELECT_EVENT) {
                dispatch(basket3DActions.selectGroup(undefined));
            } else if(event === events.CAMERA_CHANGE) {
                if(data.position && data.target) {
                    //dispatch(configuratorActions.setCamera({position: data.position, target: data.target}));
                }
            } else if(event === events.MOVE_GROUP) {
                dispatch(basket3DActions.moveGroup(data.groupId, data.position));
            }
        });

        return () => {
            EventEmitter.unsubscribe(eventTypes.VIEWER_EVENTS, subscriptionId);
        }

    }, [])

    const onAddProduct = async () => {
        if(cartId) {
            await dispatch(basketActions.save3DSnapshot());
            console.log('cartif: ' + cartId);
            dispatch(basketActions.startAddProduct(cartId));
            navigate(urls.home(langId));
        }
    }

    const onShowBasket = async () => {
        if(cartId) {
            await dispatch(basketActions.save3DSnapshot());
            navigate(urls.home(langId));
            setTimeout(() => {
                dispatch(showPopup({dialog: 'baskets'}));
                dispatch(basketActions.editCart(cartId));
            }, 200);
        }
    }

    return <Cart3DPanel loading={loading} cartId={cartId} cart={cart} cart3D={cart3D}
                        onAddProduct={onAddProduct} onShowBasket={onShowBasket}
                        />

}